import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { PRIMARY_COLOR } from 'styles/theme';

export const PdfPreviewText = (): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <>
            <Typography variant="h5" style={{ marginTop: '0.5rem' }}>
                {t('sendDashboard.layoutMessage')}
                {': '}
                {/* the `target` and `rel` attributes are for opening a new tab upon clicking */}
                <a
                    href="https://docs.manty.eu/comment-%C3%A9diter-des-rapports-pdf"
                    style={{ color: PRIMARY_COLOR }}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t('sendDashboard.layoutMessageTutorialLink')}
                </a>
            </Typography>
            <Typography variant="body1" style={{ marginTop: '0.5rem' }}>
                {t('sendDashboard.layoutFiltersMessage')}
            </Typography>
        </>
    );
};
